import Icon from '../components/Icon.vue'

Icon.register({
  'phone-square-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM383.6 339.4c0.2-0.9 0.4-2.4 0.4-3.4-0.3-5.3-4.3-11.5-9.1-13.8l-70-30c-1.6-0.6-4.2-1.2-5.9-1.2-3.8 0.2-9 2.7-11.6 5.5l-31 37.9c-41.5-19.6-91.2-69.2-110.8-110.8l37.9-31c2.8-2.6 5.3-7.8 5.5-11.6-0.1-1.7-0.6-4.3-1.2-5.9l-30-70c-2.3-4.8-8.5-8.8-13.8-9.1-0.9 0-2.5 0.2-3.4 0.4l-65 15c-6.2 1.7-11.4 8.2-11.6 14.6 0 160.3 130 290 290 290 6.6 0 13.1-5.2 14.6-11.6z'
      }
    ]
  }
})
